function pack(lang) {
  const D = {
    ja: {
      onboarding: { interestTitle: '興味のある分野を選んでください', interestSubtitle: 'あなたに合う情報をお届けします' },
      creditCharge: {
        title: 'Mingoクレジットチャージ', balance: '保有クレジット', unit: '{n}',
        amountTitle: 'チャージする数量', amountPh: 'クレジット数', notePh: '振込名義など（任意）',
        noticeTitle: 'ご案内', notice1: '確認後にクレジットが付与されます。',
        notice2: 'アプリ内の注文確定用です（店舗では現金払い）。',
        historyTitle: 'チャージ申請履歴', statusApproved: '付与済み', statusRejected: '却下', statusPending: '待機中',
        submit: 'チャージ申請', success: '申請を受け付けました。確認後に付与されます。', fail: '申請に失敗しました。',
      },
    },
    'zh-CN': {
      onboarding: { interestTitle: '请选择你感兴趣的领域', interestSubtitle: '我们会为你推荐相关信息' },
      creditCharge: {
        title: '充值 Mingo 积分', balance: '当前积分', unit: '{n}',
        amountTitle: '充值数量', amountPh: '积分数', notePh: '付款备注（选填）',
        noticeTitle: '说明', notice1: '审核通过后到账。', notice2: '仅用于应用内确认订单（到店仍付现金）。',
        historyTitle: '充值申请', statusApproved: '已到账', statusRejected: '已拒绝', statusPending: '待审核',
        submit: '提交申请', success: '已收到申请，审核后到账。', fail: '提交失败。',
      },
    },
    'zh-TW': {
      onboarding: { interestTitle: '請選擇你感興趣的領域', interestSubtitle: '我們會為你推薦相關資訊' },
      creditCharge: {
        title: '儲值 Mingo 點數', balance: '目前點數', unit: '{n}',
        amountTitle: '儲值數量', amountPh: '點數', notePh: '付款備註（選填）',
        noticeTitle: '說明', notice1: '審核通過後入帳。', notice2: '僅用於 App 內確認訂單（到店仍付現金）。',
        historyTitle: '儲值申請', statusApproved: '已入帳', statusRejected: '已拒絕', statusPending: '待審核',
        submit: '送出申請', success: '已收到申請，審核後入帳。', fail: '送出失敗。',
      },
    },
    hi: {
      onboarding: { interestTitle: 'आपकी रुचि क्या है?', interestSubtitle: 'हम आपके हिसाब से जानकारी देंगे' },
      creditCharge: {
        title: 'Mingo क्रेडिट', balance: 'आपके क्रेडिट', unit: '{n}',
        amountTitle: 'कितने क्रेडिट जोड़ें', amountPh: 'क्रेडिट संख्या', notePh: 'नोट (वैकल्पिक)',
        noticeTitle: 'जानकारी', notice1: 'समीक्षा के बाद क्रेडिट जुड़ेंगे।', notice2: 'इन-ऐप ऑर्डर पुष्टि के लिए (दुकान पर नकद)।',
        historyTitle: 'आपके अनुरोध', statusApproved: 'जमा', statusRejected: 'अस्वीकृत', statusPending: 'लंबित',
        submit: 'टॉप-अप अनुरोध', success: 'अनुरोध मिल गया। समीक्षा बाद जुड़ेंगे।', fail: 'अनुरोध नहीं भेजा गया।',
      },
    },
    th: {
      onboarding: { interestTitle: 'สนใจหมวดไหน?', interestSubtitle: 'เราจะแนะนำข้อมูลที่เหมาะกับคุณ' },
      creditCharge: {
        title: 'เติมเครดิต Mingo', balance: 'เครดิตคงเหลือ', unit: '{n}',
        amountTitle: 'จำนวนที่ต้องการเติม', amountPh: 'จำนวนเครดิต', notePh: 'หมายเหตุ (ไม่บังคับ)',
        noticeTitle: 'หมายเหตุ', notice1: 'ตรวจแล้วค่อยเติมเครดิต', notice2: 'ใช้ยืนยันออเดอร์ในแอป (จ่ายเงินสดที่ร้าน)',
        historyTitle: 'คำขอเติม', statusApproved: 'เติมแล้ว', statusRejected: 'ปฏิเสธ', statusPending: 'รอดำเนินการ',
        submit: 'ส่งคำขอ', success: 'รับคำขอแล้ว จะเติมหลังตรวจ', fail: 'ส่งไม่สำเร็จ',
      },
    },
    id: {
      onboarding: { interestTitle: 'Anda tertarik bidang apa?', interestSubtitle: 'Kami akan menyesuaikan informasi untuk Anda' },
      creditCharge: {
        title: 'Isi kredit Mingo', balance: 'Kredit Anda', unit: '{n}',
        amountTitle: 'Berapa kredit ditambah', amountPh: 'Jumlah kredit', notePh: 'Catatan (opsional)',
        noticeTitle: 'Catatan', notice1: 'Kredit ditambah setelah ditinjau.', notice2: 'Hanya untuk konfirmasi pesanan di app (bayar tunai di toko).',
        historyTitle: 'Permintaan Anda', statusApproved: 'Masuk', statusRejected: 'Ditolak', statusPending: 'Menunggu',
        submit: 'Ajukan isi ulang', success: 'Permintaan diterima. Kredit ditambah setelah ditinjau.', fail: 'Gagal mengirim.',
      },
    },
  };
  return D[lang] || {};
}

export function getLeftoverHardcodedOverlay(lang) {
  return pack(lang);
}
